import i18n from "i18n";
import moment from "moment";
import { ROUTE_PATH } from "utils/constants/routePath";

// ปลายทางของลิงก์ปุ่ม "อัพโหลด สลิป" ในอีเมล (redirect=room-booking-payment)
// room มาจาก API: "room" = ห้องซ้อม, อื่น ๆ = id ของ Music Hall
// booking_id ทำให้การ์ดของ booking นั้นเปิด popup แจ้งการชำระเงินเอง
export const ROOM_BOOKING_PAYMENT_PATH = ({ id, room }) =>
  !id || !room
    ? ROUTE_PATH.HOME
    : `${ROUTE_PATH.MUSIC_HALL_AND_PRACTICE}/${encodeURIComponent(
        room,
      )}?booking_id=${encodeURIComponent(id)}`;

// ข้อมูลการเปลี่ยนวันจัดงานสำหรับแจ้งลูกค้า
// - วันที่แสดง = วันแรกที่ลูกค้าขอ ไม่ใช่วันที่แอดมินเปลี่ยนรอบก่อนหน้า
// - เหตุผล = ของการเปลี่ยนครั้งล่าสุด เพราะเป็นเหตุผลที่ทำให้มาอยู่วันปัจจุบัน
// - ถ้าย้ายกลับมาเป็นวันเดิมที่ลูกค้าขอแล้ว ถือว่าไม่มีอะไรต้องแจ้ง
export const RENDER_BOOKING_DATE_CHANGED = (
  booking_date,
  booking_date_history,
) => {
  if (!booking_date_history || booking_date_history.length === 0) return null;
  const originalDate = booking_date_history[0].from;
  if (
    moment(originalDate).format("YYYY-MM-DD") ===
    moment(booking_date).format("YYYY-MM-DD")
  ) {
    return null;
  }
  return {
    from: originalDate,
    reason: booking_date_history[booking_date_history.length - 1].reason,
  };
};

// ห้องซ้อมดนตรีปิดทุกวันจันทร์ (0=อาทิตย์ 1=จันทร์) ต้องตรงกับ PRACTICE_ROOM_CLOSED_WEEKDAY ฝั่ง API
export const PRACTICE_ROOM_CLOSED_WEEKDAYS = [1];
export const IS_PRACTICE_ROOM_CLOSED_DAY = (date) =>
  !!date && PRACTICE_ROOM_CLOSED_WEEKDAYS.includes(moment(date).day());

const T_OPTIONS = { ns: "common", nsSeparator: false, keySeparator: false };

// error ที่ API ตอบกลับมาถูก join ด้วย ", " และเป็นภาษาอังกฤษเสมอ
// แปลตามภาษาที่เลือก ถ้าไม่มีคำแปล (error ที่ไม่ได้ตั้งใจ) ใช้ fallback แทน จะได้ไม่โชว์ข้อความดิบให้ลูกค้า
export const RENDER_API_ERROR_MESSAGE = (res, fallback) => {
  const message = res?.data?.error?.message;
  if (!message) return fallback;
  const messages = String(message)
    .split(", ")
    .map((e) => e.trim())
    .filter((e) => e)
    .map((e) => (i18n.exists(e, T_OPTIONS) ? i18n.t(e, T_OPTIONS) : fallback));
  return [...new Set(messages)].join(" ") || fallback;
};

// error ที่ต้องกลับไปแก้ที่หน้าเลือกวัน/เวลา (step 4)
const BOOKING_DATE_ERRORS = [
  "Booking date must not be in the past.",
  "Room is not available on selected date/time.",
  "Alternative date is invalid.",
  "Maximum 2 alternative dates allowed.",
  "Alternative dates must not be duplicated.",
  "Alternative date must not be in the past.",
  "Alternative date must not be the same as the event date.",
  "Alternative date is not available.",
];

export const IS_BOOKING_DATE_ERROR = (res) => {
  const message = res?.data?.error?.message;
  if (!message) return false;
  return BOOKING_DATE_ERRORS.some((e) => String(message).includes(e));
};

export const ROOM_BOOKING_RENDER_STATUS = (status) => {
  switch (status) {
    case "1":
      return {
        labelEn: "Draft",
        labelTh: "แบบร่าง",
        txtColor: "#4B1E78",
        bgColor: "#FFF500",
      };
    case "2":
      return {
        labelEn: "Waiting for Confirm from Admin",
        labelTh: "รอการยืนยันจากแอดมิน",
        txtColor: "#4B1E78",
        bgColor: "#FFF500",
      };
    case "3":
      return {
        labelEn: "Please transfer and upload slip",
        labelTh: "กรุณาโอนเงินและอัพโหลดสลิป",
        txtColor: "#FFFFFF",
        bgColor: "#FF8900",
      };
    case "4":
      return {
        labelEn: "Waiting for Slip Confirmation from Admin",
        labelTh: "รอการยืนยันสลิปจากแอดมิน",
        txtColor: "#FFFFFF",
        bgColor: "#4B42A8",
      };
    case "5":
      return {
        labelEn: "Booking Success",
        labelTh: "จองสำเร็จ",
        txtColor: "#FFFFFF",
        bgColor: "#3F830D",
      };
    case "6":
      return {
        labelEn: "Rejected by Admin",
        labelTh: "ถูกปฏิเสธโดยแอดมิน",
        txtColor: "#FFFFFF",
        bgColor: "#E22727",
      };
    case "7":
      return {
        labelEn: "Cancelled by User",
        labelTh: "ยกเลิกโดยผู้ใช้",
        txtColor: "#FFFFFF",
        bgColor: "#E22727",
      };
    case "8":
      return {
        labelEn: "Cancelled by Admin",
        labelTh: "ยกเลิกโดยแอดมิน",
        txtColor: "#FFFFFF",
        bgColor: "#E22727",
      };
    default:
      return {
        labelEn: "Not Specified",
        labelTh: "ไม่ระบุ",
        txtColor: "#4B1E78",
        bgColor: "#FFF500",
      };
  }
};
